import  styles from './ButtonContainer.module.css'
import React, {ReactNode} from "react";

interface IButtonContainerProps
{
    children: ReactNode| undefined
    resize?:boolean
    my?:number
    clsCont?:string

}

const xBuild = (children: ReactNode)=>{
    const x = React.Children.map(children, (child) => (
        <div className={styles.xItem}>{child}</div>
    ))
    return x


}

export default function ButtonContainer({resize,children,my, clsCont}:IButtonContainerProps)
{
    return (
        <div className={[styles.mainCont, resize ? styles.rsCont : "", clsCont ? clsCont : ""].join(' ')} style={{margin: `${my ? my : 0}px 0`}}>
            {children}
        </div>
    )
}